// import FacebookLogin from '@greatsumini/react-facebook-login';
// 
// export default function FacebookLoginButton() {
// 
//     return (
//         <FacebookLogin
//             appId="547088816830000"
//             onSuccess={(response) => {
//                 console.log('Login Success!');
//                 console.log('id: ', response.id);
//                 console.log(response);
//             }}
//             onFail={(error) => {
//                 console.log('Login Failed!');
//                 console.log('status: ', error.status);
//             }}
//             onProfileSuccess={(response) => {
//                 console.log('!!!!!!!!!!!!!!!!!!!!!!!!')
//                 console.log(response.email);
//                 console.log('!!!!!!!!!!!!!!!!!!!!!!!!')
//                 console.log('Get Profile Success!');
//                 console.log('name: ', response.name);
//             }}
//         />
//     );
// }



import React from 'react';
import FacebookLogin from 'react-facebook-login';
import './LoginButtons.css'; // CSS 파일 임포트

const LoginForm = (props) => {
    const facebook_client_id = process.env.REACT_APP_FACEBOOK_CLIENT_ID;
    const handleFacebookCallback = (response) => {
        if (response?.status === "unknown") {
            console.error('Sorry!', 'Something went wrong with Facebook login.');
            return;
        }
        console.log('!!!!!!!!!!!!!!!!');
        console.log(response);
        console.log('!!!!!!!!!!!!!!!!');
    }

    return (
        <div className="login-button facebook-login-button"> {/* 클래스 이름 추가 */}
            <FacebookLogin
                buttonStyle={{ padding: "6px", width: "100%", height: "100%" }} // 버튼 스타일 추가
                appId={facebook_client_id}  // Facebook Developer Console에서 가져온 앱 ID
                autoLoad={false}
                fields="name,email,picture"
                callback={handleFacebookCallback} />
        </div>
    );
};

export default LoginForm;


// version: 1
// frontend:
// phases:
// preBuild:
// commands:
// - npm ci--cache.npm--prefer - offline
// build:
// commands:
// - npm run build--force
// artifacts:
// baseDirectory: build
// files:
// - '**/*'
// cache:
// paths:
// - .npm/**/ *
